<template lang="pug">
section.section.main-content
  .container
    h1.title.is-1 Reportes
    .columns
      .column.is-3
        aside.menu
          p.menu-label gráficos
          ul.menu-list
            li
              a(@click="updateReport('by-end-states')"
              :class="{'is-active': graph == 'by-end-states'}"
              v-if="roleBroker") Cotizaciones por estados finales

            //- li
            //-   a(@click="updateReport('by-middle-states')"
            //-   :class="{'is-active': graph == 'by-middle-states'}"
            //-   v-if="roleBrokerAdministrator") Cotizaciones por estados intermedios
            li
              a(@click="updateReport('by-lp-end-states')"
              :class="{'is-active': graph == 'by-lp-end-states'}"
              v-if="!roleBroker") Cantidad de cotizaciones finalizadas

            //- li
            //-   a(@click="updateReport('by-lp-middle-states')"
            //-   :class="{'is-active': graph == 'by-lp-middle-states'}"
            //-   v-if="!roleBroker") Cotizaciones por estado intermedios
            li
              a(@click="updateReport('avg-by-lp-end-states-premium')"
              :class="{'is-active': graph == 'avg-by-lp-end-states-premium'}"
              v-if="!roleBroker") Cotizaciones finalizadas en montos acumulados
            li
              a(@click="updateReport('avg-quotation-lifetime')"
              :class="{'is-active': graph == 'avg-quotation-lifetime'}"
              v-if="!roleBroker") Tiempo promedio de cotizaciones finalizadas
            li
              a(@click="updateReport('avg-quotation-lifetime-per-area')"
              :class="{'is-active': graph == 'avg-quotation-lifetime-per-area'}"
              v-if="!roleBroker") Tiempo promedio de cotizaciones por área
            li
              a(@click="updateReport('avg-obs-per-area')"
              :class="{'is-active': graph == 'avg-obs-per-area'}"
              v-if="!roleBroker") Cantidad promedio de observaciones por cotización
        br
        aside.menu(v-if="graph != 'default'")
          p.menu-label filtros
          ul.menu-list
            li
              b-field(label="Equipo" v-if="(roleAdministrator || roleTeamSupervisor || roleExecutiveManager)")
                b-select(placeholder="Selecciona" v-model="team" @input="selectTeam()")
                  option(:value='-1') Todos
                  option(v-for="user in users" :value="user.id") {{user.full_name}}

              b-field(label="Brokers" v-if="(roleAdministrator || roleExecutiveTeamSupervisor) & !roleBroker")
                b-select(placeholder="Selecciona" v-model="broker")
                  option(:value='-1') Todos
                  option(v-for="user in brokers" :value="user.id") {{user.full_name}}

              b-field(v-if="!showYearSelect" label="Rango de fechas")
                b-datepicker(placeholder="click para seleccionar"
                icon="calendar-today"
                v-model="dates"
                range)

              b-field(label="Año" v-if="showYearSelect")
                b-select(placeholder="Selecciona" v-model="year")
                  option(:value='-1') Todos
                  option(v-for="year in years" :value="year") {{year}}

              b-field(label="Ramo")
                b-select(placeholder="Selecciona" v-model="ramo")
                  option(:value='-1') Todos
                  option(v-for="product in products" :value="product.id") {{product.name}}
              .additional
                b-field(label="Gestiones Adicionales")
                b-checkbox(
                  class="check position"
                  ref="without"
                  :native-value="-1"
                  @input="withoutAdditionalManagement(-1,without)"
                ) Sin gestiones adicionales 
                b-checkbox(
                    class="check"
                    :ref="additionalManagement.name"
                    v-model="additionalManagementSelected"
                    :native-value="additionalManagement.id"
                    :disabled="disabledAdditionalManagements"
                    @input="changeCheckbox(additionalManagement.id, additionalManagement.name)"
                    v-for="additionalManagement in additionalManagementList"
                    ) {{ additionalManagement.name }}
            li
              br
              a.button.is-info.is-small(@click="updateReport(graph)") Aplicar
      .column
        .empty(v-if="graph == 'default'") ← Selecciona un gráfico
        charts(:options="chartOptions" v-else)
</template>


<script>
import moment from 'moment';
import { getAdditionalManagement } from '../services/Commons';
import { getProductsByCompany } from '../services/services';
import { RepositoryFactory } from '@/services/RepositoryFactory';
import { getExecutiveList } from '../services/User/executive';
import { isRoleAdministrator,
  isRoleOperative, 
  isRoleTeamSupervisor,
  isBrokerAdministrator,
  isExecutiveManager,
  isExecutiveTeamSupervisor,
  isBroker,
  isExecutive } from '@/mixins/user';

import { getBrokersAvailableToUser } from '../services/User/broker';
import { companies } from '../globals';
const ProductRepository = RepositoryFactory.get('products')
const StatsRepository = RepositoryFactory.get('stats')


export default {
  data() {
    return {
      without:"without",
      graph: 'default',
      dates: [],
      additionalManagementList: [],
      additionalManagementSelected: [],
      querysAdditionalManagements: [],
      disabledAdditionalManagements: false,
      products: [],
      filters: [],
      users: [],
      brokers: [],
      years: [
        2020,
        2021,
      ],
      labelAxisY: "Total",
      year: -1,
      ramo: -1,
      broker: -1,
      team: -1,
      chartOptions: {
        title: {
            text: 'Cotizaciones'
        },
        series: []
      }
    }
  },
  watch: {
    dates: function (val) {
      if (val) {
        let from_date = moment(val[0]).format("YYYY-MM-DD")
        let to_date = moment(val[1]).format("YYYY-MM-DD")
        
        this.addFilter('from_date', from_date)
        this.addFilter('to_date', to_date)
      }
    },
    ramo: function (val) {
      if (val > 0)
        this.addFilter('product', val)
      else
        this.removeFilter('product')
    },
    team: function (val) {
      if (val > 0)
        this.addFilter('user', val)
      else
        this.removeFilter('user')
    },
    broker: function (val) {
      if (val > 0)
        this.addFilter('user', val)
      else
        this.removeFilter('user')
    },
    year: function (val) {
      if (val > 0)
        this.addFilter('year', val)
      else
        this.removeFilter('year')
    },
    additionalManagementSelected: function (vals) {
      if (vals != []){
          this.querysAdditionalManagements = [];
          vals.forEach( (val) => {
            this.querysAdditionalManagements.push(`additional_mgmts=${val}`);
          })
      }
      else
        this.removeFilter('additional_mgmts')
    },
  },
  computed: {
    showAllCharts() {
      return !isBroker()
    },
    roleBroker() {
      return isBroker()
    },
    roleBrokerAdministrator() {
      return isBrokerAdministrator()
    },
    roleAdministrator() {
      return isRoleAdministrator();
    },
    roleOperative() {
      return isRoleOperative();
    },
    roleExecutiveTeamSupervisor() {
      return isExecutiveTeamSupervisor();
    },
    roleTeamSupervisor() {
      return isRoleTeamSupervisor();
    },
    roleExecutiveManager() {
      return isExecutiveManager();
    },
    showYearSelect() {
      if( this.graph == 'avg-obs-per-area' || this.graph == 'avg-quotation-lifetime-per-area' ){
        return false;
      }
      return true;
    }
  },
  created() {
    this.fetchProducts()
    .then((response) => {
      response.data.forEach((data) => {
        this.products = this.products.concat(data.products)
      })
    })
    if ( isRoleAdministrator() || isRoleTeamSupervisor() ) {
      this.fetchTeam().then((response) => {
        this.users = response.data.in_charge
      })
    }
    getAdditionalManagement().then((result) => {
      this.additionalManagementList = result.data;
    })

    if( isExecutiveManager() ) {
      getExecutiveList('team-supervisor').then((response) => {
          this.users = response.data
      })
    }
  },
  methods: {
    fetchProducts() {
      return ProductRepository.getList()
    },
    fetchTeam() {
      return StatsRepository.getTeam()
    },
    genFilters() {
      const uniqueQueryParameters = Object.entries(this.filters)
                .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
                .join('&')
      const multipleQueryParameters = Object.entries(this.querysAdditionalManagements)
                .map(([k, v]) => `${v}`)
                .join('&')

      const querysParameters = `${uniqueQueryParameters}&${multipleQueryParameters}` 
      console.log("Querys", querysParameters);
      return querysParameters;
    },
    addFilter(name, value) {
      this.filters[name] = value
    },
    removeFilter(name) {
      delete this.filters[name]
    },
    drawPie(remoteData) {
      let data = []

      remoteData.forEach((obj) => {
        data.push({
              name: obj.name,
              y: obj.total,
              sliced: true,
              selected: true
          })
      })

      this.chartOptions['series'] = [{
          type: 'pie',
          name: 'Cotizaciones',
          colorByPoint: true,
          data: data
        }]
    },
    drawBar(remoteData, type, categories, plotOptions) {
      this.chartOptions = {
        chart: {
          type: type
        },
        title: {
          text: 'Estados'
        },
        xAxis: {
          categories: categories
        },
        yAxis: {
          min: 0,
          title: {
            text: this.labelAxisY
          }
        },
        plotOptions: plotOptions,
        series: remoteData.series
      }

      if (this.brokers)
        this.brokers = remoteData.brokers
    },
    fetchData() {
      this.chartOptions['series'] = []

      if (this.graph == 'by-end-states') {

        this.labelAxisY = "#Total"
        StatsRepository.getAvgByEndStates(this.genFilters())
          .then((response) => this.drawBar(response.data, 
            'column', ['Q1', 'Q2', 'Q3', 'Q4'], {
            column: {
              stacking: 'normal'
            }
          }))

      } else if (this.graph == 'by-middle-states') {
        this.labelAxisY = "#Total"
        StatsRepository.getAvgByMiddleStates(this.genFilters())
          .then((response) => this.drawBar(response.data, 
            'bar', ['Broker', 'En Curso (La Positiva)'], {
            column: {
              stacking: 'normal'
            }
          }))

      } else if (this.graph == 'by-lp-end-states') {
        this.labelAxisY = "Nº Total"
        StatsRepository.getAvgByLPEndStates(this.genFilters())
          .then((response) => this.drawBar(response.data, 
            'column', ['Q1', 'Q2', 'Q3', 'Q4'], {}))

      } else if (this.graph == 'by-lp-middle-states') {
        this.labelAxisY = "#Total"
        StatsRepository.getAvgByLPMiddleStates(this.genFilters())
          .then((response) => this.drawBar(response.data, 
            'column', ['Q1', 'Q2', 'Q3', 'Q4'], {}))

      } else if (this.graph == 'avg-by-lp-end-states-premium') {
        
        this.labelAxisY = "Nº Total en miles de Soles S/"
        StatsRepository.getAvgByPremium(this.genFilters())
          .then((response) => this.drawBar(response.data, 
            'column', ['Q1', 'Q2', 'Q3', 'Q4'], {}))

        getProductsByCompany(companies.LPV).then((result) => {
          this.products = JSON.parse(result.data);
        })

      } else if (this.graph == 'avg-quotation-lifetime') {
        this.labelAxisY = "N° de días en promedio"
        StatsRepository.getAvgQuotationLifeTime(this.genFilters())
          .then((response) => this.drawBar(response.data, 
            'column', ['Q1', 'Q2', 'Q3', 'Q4'], {}))

      } else if (this.graph == 'avg-quotation-lifetime-per-area') {
        this.labelAxisY = "N° de días en promedio"
        StatsRepository.getAvgQuotationLifeTimePerArea(this.genFilters())
          .then((response) => this.drawBar(response.data, 
            'column', ['BROKER', 'COMERCIAL', 'TECNICA'], {}))

      } else if (this.graph == 'avg-obs-per-area') {
        this.labelAxisY = "Nº de observaciones en promedio"
        StatsRepository.getAvgObsPerArea(this.genFilters())
          .then((response) => this.drawBar(response.data, 
            'column', ['BROKER', 'COMERCIAL', 'TECNICA'], {}))

      }
    },
    updateReport: function (graph) {
      this.graph = graph
      this.fetchData()
    },

    selectTeam() {
      if(isExecutive) {
        getBrokersAvailableToUser(this.team).then((result) => {
          this.brokers = result.data;
          this.broker = -1;
        })
      }
    },

    changeCheckbox(id, name) {
        const body = {
            additional_management_id: id,
            state: this.$refs[name]["0"].$refs.input.checked,
        }
    },
    withoutAdditionalManagement(id, name) {
      if( this.$refs["without"].$refs.input.checked){
        this.disabledAdditionalManagements = true
        this.additionalManagementSelected = [-1];
      } else{
        this.disabledAdditionalManagements = false;
        this.additionalManagementSelected = [];
      }
    }
  }
}
</script>

<style lang="scss">
  .empty {
    display: flex;
    height: 100%;
    justify-content: center;
    align-items: center;
    font-weight: bold;
  }
  .additional {
    display: flex;
    flex-direction: column;
  }
  .check {
    margin-bottom: 5px;
  }
</style>